import { useQuery } from "react-query";
import { KYC_HISTORY } from "./resources";
import { VerificationService } from "./service";

export const useKycHistoryQuery = (id: string) =>
  useQuery([KYC_HISTORY, id], () => VerificationService.getKycHistory(id));
